import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';


const PUBLIC_AUTH_PATHS = [
    'auth/actions/login',
    'auth/actions/authenticate',
    'auth/actions/authenticate-admin',
    'auth/actions/refresh',
];

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(){}

    private isPublicAuthRequest(url: string): boolean {
        return PUBLIC_AUTH_PATHS.some((path) => url.includes(path));
    }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        if (this.isPublicAuthRequest(req.url)) {
            return next.handle(req);
        }

        const authToken = AuthService.getToken();

        if (!authToken || req.headers.has('Authorization')) {
            return next.handle(req);
        }

        const authRequest = req.clone({
            setHeaders: {
                Authorization: 'Bearer ' + authToken
            }
        });
        return next.handle(authRequest);
    }
}
